const getters = {
  // 基础组件
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  // 权限
  token: state => state.user.token,
  name: state => state.user.name,
  storeName: state => state.user.storeName,
  expirationReminder: state => state.user.expirationReminder,
  roles: state => state.user.roles,
  permission_routers: state => state.permission.routers,
  permissionList: state => state.user.permissionList,
  addRouters: state => state.permission.addRouters,
  // 系统管理
  roleList: state => state.system.roleList,
  allRoleUserList: state => state.system.allRoleUserList,
  roleUserList: state => state.system.roleUserList,
  roleTreeList: state => state.system.roleTreeList,
  currentRolePermiision: state => state.system.currentRolePermiision,
  storeUserList: state => state.system.storeUserList,
  organizationList: state => state.system.organizationList,
  byIdOrganization: state => state.system.byIdOrganization,
  depotList: state => state.system.depotList,
  byIdShop: state => state.system.byIdShop,
  shopList: state => state.system.shopList,
  allEmployeeList: state => state.system.allEmployeeList,

  mode2List: state => state.system.mode2List,
  expressListAll: state => state.system.expressListAll,
  orderReturnList: state => state.system.orderReturnList,
  detailsorderReturn: state => state.system.detailsorderReturn,
  queryShopList: state => state.system.queryShopList,
  msgTemplatesList: state => state.system.msgTemplatesList,

  // 预约管理
  appointmentListInfo: state => state.appointment.appointmentListInfo,
  calendarAppointmentList: state => state.appointment.calendarAppointmentList,
  calendarDayAppointment: state => state.appointment.calendarDayAppointment,
  // 门店与员工管理
  serviceList: state => state.storeAndStaff.serviceList,
  rowService: state => state.storeAndStaff.rowService,
  storeList: state => state.storeAndStaff.storeList,
  staffList: state => state.storeAndStaff.staffList,
  schedulingList: state => state.storeAndStaff.schedulingList,
  guiderWorkTimeList: state => state.storeAndStaff.guiderWorkTimeList,
  disabledSchedulingList: state => state.storeAndStaff.disabledSchedulingList,
  serviceCategoryList: state => state.storeAndStaff.serviceCategoryList,
  // 订单管理
  orderList: state => state.order.orderList,
  orderDetail: state => state.order.orderDetail,
  // 会员管理
  memberList: state => state.member.memberList,
  purchaseHistory: state => state.member.purchaseHistory,
  appointmentRecord: state => state.member.appointmentRecord,
  writeOffRecord: state => state.member.writeOffRecord,
  recordWithCard: state => state.member.recordWithCard,
  // 商户管理
  merchantList: state => state.merchant.merchantList,
  oldMerchantList: state => state.merchant.oldMerchantList,
  rechargeList: state => state.merchant.rechargeList,
  expiredDate: state => state.merchant.expiredDate,
  accountList: state => state.merchant.accountList,
  // 结算管理
  writeOffList: state => state.writeOff.writeOffList,
  currentOrderDetails: state => state.writeOff.currentOrderDetails,
  boughtProductList: state => state.writeOff.boughtProductList,
  // 预约服务管理
  productList: state => state.product.productList,
  rowProduct: state => state.product.rowProduct,
  categoryList: state => state.product.categoryList,
  commondityList: state => state.product.commondityList,
  virtualCommodityList: state => state.product.virtualCommodityList,
  // 大屏管理
  screenList: state => state.screen.screenList,
  rowScreen: state => state.screen.rowScreen,
  getNumRecordList: state => state.screen.getNumRecordList,
  // 活动管理
  activityCategoryList: state => state.activity.activityCategoryList,
  onlineMallstoreList: state => state.activity.onlineMallstoreList,
  offlineCategoryList: state => state.activity.offlineCategoryList,
  offlineBrandList: state => state.activity.offlineBrandList,
  offlineGoodsListResult: state => state.activity.offlineGoodsListResult,
  crossQueryResult: state => state.activity.crossQueryResult,
  goodsByBarcode: state => state.activity.goodsByBarcode,
  activityList: state => state.activity.activityList,
  activeListCount: state => state.activity.activeListCount,
  allActivityList: state => state.activity.allActivityList,
  checkActivityRecordList: state => state.activity.checkActivityRecordList,
  checkActivityRecordListCount: state =>
    state.activity.checkActivityRecordListCount,
  allCheckActivityRecordList: state =>
    state.activity.allCheckActivityRecordList,
  fullDiscountDetails: state => state.activity.fullDiscountDetails,
  fullReductionDetails: state => state.activity.fullReductionDetails,
  fullDeliveruDetails: state => state.activity.fullDeliveruDetails,
  fullDeliveruDetailsOverlay: state =>
    state.activity.fullDeliveruDetailsOverlay,
  selectType: state => state.activity.selectType,
  overlayType: state => state.activity.overlayType,
  fullIncreasePurchaseDetails: state =>
    state.activity.fullIncreasePurchaseDetails,
  combinationDetails: state => state.activity.combinationDetails,
  specialRuleDetails: state => state.activity.specialRuleDetails,
  goodsIsUsedList: state => state.activity.goodsIsUsedList,
  subscribeActiveListCount: state => state.activity.subscribeActiveListCount,
  subscribeActivityList: state => state.activity.subscribeActivityList,
  allSubscribeActivityList: state => state.activity.allSubscribeActivityList,
  activityListDetails: state => state.activity.activityListDetails,
  getActivityInfos: state => state.activity.getActivityInfos,
  sendCoupon: state => state.activity.sendCoupon,
  allSendCouponList: state => state.activity.allSendCouponList,
  couponPackage: state => state.activity.couponPackage,
  addSubCouponLog: state => state.activity.addSubCouponLog,
  subscribeActList: state => state.activity.subscribeActList,
  subscrobeActListCount: state => state.activity.subscrobeActListCount,
  allSubscribeActList: state => state.activity.allSubscribeActList,
  allSubscrobeActListCount: state => state.activity.allSubscrobeActListCount,
  chargeList: state => state.activity.chargeList,
  // 导购相关 唤醒会员设置
  wakeUpMember: state => state.guider.wakeUpMember,
  allWakeUpMemberList: state => state.guider.allWakeUpMemberList,
  guiderReward: state => state.guider.guiderReward,
  allGuiderRewardList: state => state.guider.allGuiderRewardList,
  guiderOrderDetails: state => state.guider.guiderOrderDetails,
  allGuiderOrderDetailsList: state => state.guider.allGuiderOrderDetailsList,
  wakeUpConfig: state => state.guider.wakeUpConfig,
  // 优惠券
  allRules: state => state.rules.allRules,
  allRulesTotal: state => state.rules.allRulesTotal,
  allBeltRules: state => state.rules.allBeltRules,
  allBeltRulesTotal: state => state.rules.allBeltRulesTotal,
  invalidateRulesCode: state => state.rules.invalidateRulesCode,
  ruleValidTime: state => state.rules.ruleValidTime,
  tabList: state => state.rules.tabList,
  customerFeatureList: state => state.rules.customerFeatureList,
  cdkey: state => state.rules.cdkey,
  sendCouponsListTotal: state => state.rules.sendCouponsListTotal,
  invalidateCouponCode: state => state.rules.invalidateCouponCode,
  sendCouponsList: state => state.rules.sendCouponsList,
  publishCouponCode: state => state.rules.publishCouponCode,
  sendValidTime: state => state.rules.sendValidTime,
  // 商品库
  goodsCategoryTree: state => state.goodsLib.goodsCategoryTree,
  goodsCategoryList: state => state.goodsLib.goodsCategoryList,
  allBrandActivityList: state => state.goodsLib.allBrandActivityList,
  brandDetail: state => state.goodsLib.brandDetail,
  allBrandList: state => state.goodsLib.allBrandList,
  attributeList: state => state.goodsLib.attributeList,
  attributeDetails: state => state.goodsLib.attributeDetails,
  allAttributeList: state => state.goodsLib.allAttributeList,
  attributeEditDetails: state => state.goodsLib.attributeEditDetails,
  specificationDetails: state => state.goodsLib.specificationDetails,
  specificationEditDetails: state => state.goodsLib.specificationEditDetails,
  specificationList: state => state.goodsLib.specificationList,
  allSpecificationList: state => state.goodsLib.allSpecificationList,
  specList: state => state.goodsLib.specList,
  attrList: state => state.goodsLib.attrList,
  supplierList: state => state.goodsLib.supplierList,
  salesChannels: state => state.goodsLib.salesChannels,
  mallGoodsList: state => state.goodsLib.mallGoodsList,
  allMallGoodsList: state => state.goodsLib.allMallGoodsList,
  goodsDetails: state => state.goodsLib.goodsDetails,
  //签到活动
  activityCenterList: state => state.activityCenter.activityCenterList,
  activityCenterAllList: state => state.activityCenter.activityCenterAllList,
  editActivity: state => state.activityCenter.editActivity,
  detailActivity: state => state.activityCenter.detailActivity,
  myActivityList: state => state.activityCenter.myActivityList,
  gameTypeList: state => state.activityCenter.gameTypeList,
  allGameTypeList: state => state.activityCenter.allGameTypeList,
  winningList: state => state.activityCenter.winningList,
  allWinningList: state => state.activityCenter.allWinningList,
  collectCardWinningList: state => state.activityCenter.collectCardWinningList,
  allCollectCardWinningList: state =>
    state.activityCenter.allCollectCardWinningList,
  teamOrderList: state => state.activityCenter.teamOrderList,
  detailsTeamOrder: state => state.activityCenter.detailsTeamOrder,
  findCouponSendByEvent: state => state.activityCenter.findCouponSendByEvent,
  subActivityList: state => state.activityCenter.subActivityList,
  allSubActivityList: state => state.activityCenter.allSubActivityList,
  subActivityDetails: state => state.activityCenter.subActivityDetails,
  subApplyActivity: state => state.activityCenter.subApplyActivity,
  allSubApplyActivity: state => state.activityCenter.allSubApplyActivity,
  chargeLists: state => state.activityCenter.chargeLists,
  subCouponLogList: state => state.activityCenter.subCouponLogList,
  allSubCouponLogList: state => state.activityCenter.allSubCouponLogList,
  subCouponLog: state => state.activityCenter.subCouponLog,
  couponPackages: state => state.activityCenter.couponPackages,
  // 微店商品
  microShopGoodsCategoryList: state =>
    state.microShop.microShopGoodsCategoryList,
  microShopGoodsCategoryDetails: state =>
    state.microShop.microShopGoodsCategoryDetails,
  microShopGoodsCategoryTree: state =>
    state.microShop.microShopGoodsCategoryTree,
  microShopGoodsList: state => state.microShop.microShopGoodsList,
  allMicroShopGoodsList: state => state.microShop.allMicroShopGoodsList,
  microShopStoreList: state => state.microShop.microShopStoreList,
  dkMicroShopStoreList: state => state.microShop.dkMicroShopStoreList,

  microShopGoodsDetails: state => state.microShop.microShopGoodsDetails,
  // 店铺装修
  indexTemp: state => state.decoration.indexTemp,
  tempDetails: state => state.decoration.tempDetails,
  storeStyle: state => state.decoration.storeStyle,
  microShopRouteList: state => state.decoration.microShopRouteList,
  //会员中心
  memberMgtList: state => state.memberCenter.memberMgtList,
  allMemberMgtList: state => state.memberCenter.allMemberMgtList,
  detMemberMgt: state => state.memberCenter.detMemberMgt,
  detailMember: state => state.memberCenter.detailMember,
  vipCardList: state => state.memberCenter.vipCardList,
  cardTypeList: state => state.memberCenter.cardTypeList,
  vipCardTypeList: state => state.memberCenter.vipCardTypeList,
  memberInfoList: state => state.memberCenter.memberInfoList,
  fansMgtList: state => state.memberCenter.fansMgtList,
  allFansMgtList: state => state.memberCenter.allFansMgtList,
  virtualGoods: state => state.memberCenter.virtualGoods,
  plusRuleList: state => state.memberCenter.plusRuleList,
  plusPageList: state => state.memberCenter.plusPageList,
  plusMemberList: state => state.memberCenter.plusMemberList,
  plusRightMoveList: state => state.memberCenter.plusRightMoveList,
  plusRuleDetails: state => state.memberCenter.plusRuleDetails,
  rightsProgress: state => state.memberCenter.rightsProgress,
  //订单中心
  orderCenterList: state => state.orderCenter.orderCenterList,
  orderAllCenterList: state => state.orderCenter.orderAllCenterList,
  detailsOrder: state => state.orderCenter.detailsOrder,
  detailsExpressOrder: state => state.orderCenter.detailsExpressOrder,
  newDetailsOrder: state => state.orderCenter.newDetailsOrder,
  logisticsList: state => state.orderCenter.logisticsList,
  showLogsistics: state => state.orderCenter.showLogsistics,
  invoiceList: state => state.orderCenter.invoiceList,

  expressList: state => state.orderCenter.expressList,
  expressModeList: state => state.orderCenter.expressModeList,
  storeExpressList: state => state.orderCenter.storeExpressList,
  cityList: state => state.orderCenter.cityList,
  detailsStoreExpres: state => state.orderCenter.detailsStoreExpres,
  detailsAdres: state => state.orderCenter.detailsAdres,
  expressShopList: state => state.orderCenter.expressShopList,
  expressPageList: state => state.orderCenter.expressPageList,
  querySupplier: state => state.orderCenter.querySupplier,
  //会员管理
  labelSystemList: state => state.memberSystem.labelSystemList,
  alllabelSystemList: state => state.memberSystem.alllabelSystemList,
  memberGroupList: state => state.memberSystem.memberGroupList,
  allMemberGroupList: state => state.memberSystem.allMemberGroupList,
  //分销中心
  relInfoList: state => state.distributionCenter.relInfoList,
  autotagList: state => state.distributionCenter.autotagList,
  detailRules: state => state.distributionCenter.detailRules,
  wxShopList: state => state.distributionCenter.wxShopList,
  distributionBillList: state => state.distributionCenter.distributionBillList,
  detailsBill: state => state.distributionCenter.detailsBill,
  detailsWithdraw: state => state.distributionCenter.detailsWithdraw,
  extractManageList: state => state.distributionCenter.extractManageList,
  extractTotal: state => state.distributionCenter.extractTotal,
  shareCenterPrice: state => state.distributionCenter.shareCenterPrice,
  detailsTimeline: state => state.distributionCenter.detailsTimeline,
  orderNewList: state => state.distributionCenter.orderNewList,
  commissionPriceList: state => state.distributionCenter.commissionPriceList,
  shareAgentList: state => state.distributionCenter.shareAgentList,
  //首页
  marketList: state => state.home.marketList,
  dynamicList: state => state.home.dynamicList,
  analysisList: state => state.home.analysisList,
  //报表中心
  spuRank: state => state.reportCenter.spuRank,
  allSpuRank: state => state.reportCenter.allSpuRank,
  brandRank: state => state.reportCenter.brandRank,
  memberRank: state => state.reportCenter.memberRank,
  pushMemberRank: state => state.reportCenter.pushMemberRank,
  reportMemberList: state => state.reportCenter.reportMemberList,
  reportCouponList: state => state.reportCenter.reportCouponList,
  reportGoodsList: state => state.reportCenter.reportGoodsList,
  //红包中心
  supplierBasucList: state => state.guiderCommission.supplierBasucList,
  storeBasucList: state => state.merchants.storeBasucList,
  storeShopInfoList: state => state.merchants.storeShopInfoList,
  redpackageOutletRelList: state =>
    state.guiderCommission.redpackageOutletRelList,
  storeBasicInfoListBox: state => state.guiderCommission.storeBasicInfoListBox,
  notRelShopList: state => state.guiderCommission.notRelShopList,
  hemiaoBrandList: state => state.guiderCommission.hemiaoBrandList,
  supplierGoodsInfoList: state => state.guiderCommission.supplierGoodsInfoList,
  hemiaoBrandBoxList: state => state.guiderCommission.hemiaoBrandBoxList,
  supplierRewardRuleInfoList: state =>
    state.guiderCommission.supplierRewardRuleInfoList,
  departBindingStoreBox: state => state.guiderCommission.departBindingStoreBox,
  detailsSupplierBasicInfo: state =>
    state.guiderCommission.detailsSupplierBasicInfo,
  supplierBrandGuiderList: state => state.merchants.supplierBrandGuiderList,
  detailsGuiderInfo: state => state.merchants.detailsGuiderInfo,
  companyCapitalFlowlist: state =>
    state.guiderCommission.companyCapitalFlowlist,
  allCompanyCapitalFlowlist: state =>
    state.guiderCommission.allCompanyCapitalFlowlist,
  salesVolumeList: state => state.auditList.salesVolumeList,
  queryProvinceList: state => state.auditList.queryProvinceList,
  detailsSalesVolume: state => state.auditList.detailsSalesVolume,
  declareList: state => state.auditList.declareList,
  detailsDeclare: state => state.auditList.detailsDeclare,
  cashOutList: state => state.auditList.cashOutList,
  companyRechargelist: state => state.guiderCommission.companyRechargelist,
  commissionReportList: state => state.guiderCommission.commissionReportList,
  shopReportList: state => state.guiderCommission.shopReportList,
  guiderReportList: state => state.guiderCommission.guiderReportList,
  marketingDynamic: state => state.guiderCommission.marketingDynamic,
  auditDynamic: state => state.guiderCommission.auditDynamic,
  sendRankingList: state => state.guiderCommission.sendRankingList,
  redpacket: state => state.guiderCommission.redpacket,
  auditCount: state => state.merchants.auditCount,
  backDeclareCount: state => state.auditList.backDeclareCount,
  //积分中心
  auditInfoList: state => state.integrationCenter.auditInfoList,
  detailsIntegralGrowth: state => state.integrationCenter.detailsIntegralGrowth,
  // okr
  taskInfo: state => state.okrWork.taskInfo,
  // 标签
  tagAttributeList: state => state.portraitLabelMgt.tagAttributeList,
  supplierReceiptList: state => state.merchants.supplierReceiptList,
};
export default getters;
